module.exports = __webpack_public_path__ + "img/minor-prize@2x.96378719.png";